/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTehtrisStatuses200ResponseStatusesInner } from './GetTehtrisStatuses200ResponseStatusesInner';
import {
    GetTehtrisStatuses200ResponseStatusesInnerFromJSON,
    GetTehtrisStatuses200ResponseStatusesInnerFromJSONTyped,
    GetTehtrisStatuses200ResponseStatusesInnerToJSON,
    GetTehtrisStatuses200ResponseStatusesInnerToJSONTyped,
} from './GetTehtrisStatuses200ResponseStatusesInner';

/**
 * 
 * @export
 * @interface GetTehtrisStatuses200Response
 */
export interface GetTehtrisStatuses200Response {
    /**
     * 
     */
    statuses: Array<GetTehtrisStatuses200ResponseStatusesInner>;
}

/**
 * Check if a given object implements the GetTehtrisStatuses200Response interface.
 */
export function instanceOfGetTehtrisStatuses200Response(value: object): value is GetTehtrisStatuses200Response {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    return true;
}

export function GetTehtrisStatuses200ResponseFromJSON(json: any): GetTehtrisStatuses200Response {
    return GetTehtrisStatuses200ResponseFromJSONTyped(json, false);
}

export function GetTehtrisStatuses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTehtrisStatuses200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': ((json['statuses'] as Array<any>).map(GetTehtrisStatuses200ResponseStatusesInnerFromJSON)),
    };
}

export function GetTehtrisStatuses200ResponseToJSON(json: any): GetTehtrisStatuses200Response {
    return GetTehtrisStatuses200ResponseToJSONTyped(json, false);
}

export function GetTehtrisStatuses200ResponseToJSONTyped(value?: GetTehtrisStatuses200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': ((value['statuses'] as Array<any>).map(GetTehtrisStatuses200ResponseStatusesInnerToJSON)),
    };
}

